// extracted by mini-css-extract-plugin
export default {"root":"glVPoox9J9sbxx2HSKCx"};